export default __webpack_public_path__ + "static/media/logo-inverted.1ce98907.svg";